<div class="w-full space-y-6">

    <!-- Page Header -->
    <div class="flex items-center justify-between pb-4 border-b border-slate-200">
        <div class="flex items-center gap-3">
            <div class="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center">
                <mat-icon class="text-slate-600">settings</mat-icon>
            </div>
            <div>
                <h2 class="text-sm font-bold tracking-widest uppercase text-slate-800">
                    Service Configuration
                </h2>
                <p class="text-xs text-slate-500 font-medium mt-0.5">
                    Manage service details and SMS schedules
                </p>
            </div>
        </div>
    </div>

    <!-- FORM CARD -->
    <div class="bg-white rounded-lg shadow border border-slate-200 px-6 py-4">

        <form #serviceForm="ngForm" (ngSubmit)="lFN_SubmitService(serviceForm)">

            <!-- FIRST ROW -->
            <div class="flex w-full gap-6 flex-col md:flex-row">

                <!-- Service Name (75%) -->
                <mat-form-field appearance="outline" class="flex-[3]">
                    <mat-label>Service Name</mat-label>
                    <mat-icon matPrefix class="text-slate-500">build</mat-icon>
                    <input matInput name="serviceName" [(ngModel)]="l_formDataService.serviceName" required
                        maxlength="150" pattern="^[A-Za-z0-9 ]+$" #serviceName="ngModel" />

                    <mat-error *ngIf="serviceForm.submitted && serviceName.invalid">
                        Alphabets, numbers & spaces only (max 150)
                    </mat-error>
                </mat-form-field>

                <!-- Default SMS Count (25%) -->
                <mat-form-field appearance="outline" class="flex-[1]">
                    <mat-label>Default SMS Count (Max-10)</mat-label>
                    <mat-icon matPrefix class="text-slate-500">sms</mat-icon>
                    <input matInput type="number" name="serviceDefaultSms"
                        [(ngModel)]="l_formDataService.serviceDefaultSms" required min="0" max="10" step="1"
                        #serviceDefaultSms="ngModel" />

                    <mat-error *ngIf="serviceForm.submitted && serviceDefaultSms.invalid">
                        Enter value between 0 and 10
                    </mat-error>
                </mat-form-field>

            </div>

            <!-- SECOND ROW -->
            <div class="flex w-full gap-6 flex-col md:flex-row items-baseline mt-4">

                <!-- Service Description -->
                <mat-form-field appearance="outline" class="flex-1">
                    <mat-label>Service Description</mat-label>
                    <mat-icon matPrefix class="text-slate-500">description</mat-icon>
                    <textarea matInput rows="1" class="resize-none" name="serviceDescription"
                        [(ngModel)]="l_formDataService.serviceDescription" maxlength="100">
          </textarea>
                </mat-form-field>

                <!-- Active -->
                <div class="flex items-center mt-2 md:mt-0">
                    <mat-checkbox name="isActive" [checked]="l_formDataService.isActive === 'YES'"
                        (change)="l_formDataService.isActive = $event.checked ? 'YES' : 'NO'">
                        <span class="text-[12px] font-semibold tracking-widest uppercase text-slate-700">
                            Active
                        </span>
                    </mat-checkbox>
                </div>

                <!-- Reset -->
                <button type="button" (click)="lFN_ResetForm(serviceForm)" class="flex-1 md:flex-none px-6 py-2.5 rounded-lg
                    text-slate-500 text-[12px] font-medium tracking-widest uppercase
                    bg-slate-100 text-slate-900
                    transition-all duration-200">
                    Reset
                </button>

                <!-- Save -->
                <button type="submit" class="px-6 py-2 rounded-md
                       bg-gradient-to-r from-slate-900 to-black
                       text-white text-[12px] font-medium tracking-widest uppercase
                       shadow hover:from-black hover:to-slate-800
                       transition-all duration-150 whitespace-nowrap">
                    {{ isEditMode ? 'Update Service' : 'Save' }}
                </button>

            </div>

        </form>
    </div>

    <!-- DETAIL CARD -->
    <div class="bg-white rounded-lg shadow border border-slate-200 px-6 py-4"
        *ngIf="l_formDataService.serviceDefaultSms >= 0 && l_formDataService.serviceDefaultSms <= 10">

        <div class="text-[14px] font-semibold text-slate-600 uppercase mb-4">
            Service SMS Schedule Details
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">

            <div *ngFor="let d of serviceDetails; let i = index" class="border border-slate-200 rounded-lg p-4">

                <div class="mb-2 text-[12px] font-semibold tracking-widest uppercase text-slate-600">
                    SMS {{ i + 1 }}
                </div>

                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Send SMS Before (Days)</mat-label>
                    <mat-icon matPrefix class="text-slate-500">schedule</mat-icon>
                    <input matInput type="number" min="1" max="365" [(ngModel)]="d.serviceSmsSendBeforeDays"
                        name="smsDay{{ i }}" required>
                </mat-form-field>

            </div>

        </div>

    </div>

    <!-- TABLE CARD -->
    <div class="bg-white rounded-lg shadow border border-slate-200 overflow-x-auto">

        <table mat-table [dataSource]="dataSource" class="w-full">
            <!-- Sr No -->
            <ng-container matColumnDef="srNo">
                <th mat-header-cell *matHeaderCellDef
                    class="bg-gray-900 text-white uppercase text-xs text-center w-24 px-4">
                    Sr No.
                </th>
                <td mat-cell *matCellDef="let row; let i = index" class="text-sm text-center px-4">
                    {{
                    ((paginator?.pageIndex ?? 0) *
                    (paginator?.pageSize ?? dataSource.data.length))
                    + i + 1
                    }}
                </td>
            </ng-container>

            <!-- Service Name -->
            <ng-container matColumnDef="serviceName">
                <th mat-header-cell *matHeaderCellDef
                    class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
                    Service Name
                </th>
                <td mat-cell *matCellDef="let s" class="text-sm px-4 whitespace-nowrap">
                    {{ s.serviceName }}
                </td>
            </ng-container>

            <!-- Description -->
            <ng-container matColumnDef="serviceDescription">
                <th mat-header-cell *matHeaderCellDef
                    class="bg-gray-900 text-white uppercase text-xs px-4 whitespace-nowrap">
                    Description
                </th>
                <td mat-cell *matCellDef="let s" class="text-sm px-4 whitespace-nowrap">
                    {{ s.serviceDescription || '-' }}
                </td>
            </ng-container>

            <!-- Default SMS Count -->
            <ng-container matColumnDef="serviceDefaultSms">
                <th mat-header-cell *matHeaderCellDef
                    class="bg-gray-900 text-white uppercase text-xs text-center px-4 whitespace-nowrap">
                    SMS Count
                </th>
                <td mat-cell *matCellDef="let s" class="text-sm text-center px-4">
                    {{ s.serviceDefaultSms }}
                </td>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="isActive">
                <th mat-header-cell *matHeaderCellDef
                    class="bg-gray-900 text-white uppercase text-xs text-center px-4 whitespace-nowrap">
                    Status
                </th>
                <td mat-cell *matCellDef="let s" class="text-center px-4">
                    <button (click)="lFN_ChangeServiceStatus(s)" class="w-20 text-center px-0 py-1.5 rounded-full
                         text-[10px] font-semibold tracking-widest uppercase
                         transition-all duration-200 border" [ngClass]="s.isActive === 'YES'
                    ? 'bg-emerald-200 text-emerald-900 border-emerald-600 hover:bg-emerald-300'
                    : 'bg-rose-200 text-rose-900 border-rose-600 hover:bg-rose-300'">
                        {{ s.isActive === 'YES' ? 'Active' : 'Inactive' }}
                    </button>
                </td>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef
                    class="bg-gray-900 text-white uppercase text-xs text-center px-4 whitespace-nowrap">
                    Actions
                </th>
                <td mat-cell *matCellDef="let s" class="text-center px-4">
                    <button mat-icon-button (click)="lFN_EditService(s)">
                        <mat-icon class="text-black">edit</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>

        <mat-paginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>

    </div>

</div>